import { render, staticRenderFns } from "./popover-preview.vue?vue&type=template&id=63789568"
import script from "./popover-preview.vue?vue&type=script&lang=js"
export * from "./popover-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63789568')) {
      api.createRecord('63789568', component.options)
    } else {
      api.reload('63789568', component.options)
    }
    module.hot.accept("./popover-preview.vue?vue&type=template&id=63789568", function () {
      api.rerender('63789568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabPrizeView/components/Infomation/popover-preview.vue"
export default component.exports